import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { schedulesShape } from 'redux/saga/entities/schedules.shape';
import classNames from 'classnames';
import shiftTimezone from 'tz-offsets';
import { SCHEDULE_SOURCE_MINDBODY } from 'constants/schedule-source';
import { CANCELLATION_LATE } from 'constants/cancellation-types';
import { TimeRange } from 'components/TimeRange/TimeRange';
import { CancellationPolicy } from '../components/CancellationPolicy';
import { MindBodyLink } from '../components/MindBodyLink';
import { messages } from './ModalStates.messages';
import { mapScheduleProperties } from '../Reservation.helpers';
export var Inquiry =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Inquiry, _PureComponent);

  function Inquiry() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Inquiry);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Inquiry)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isDisabled: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleLateCancellationConfirmation", function () {
      _this.setState(function (prevState) {
        return {
          isDisabled: !prevState.isDisabled
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleReservationRequest", function () {
      var _this$props = _this.props,
          schedule = _this$props.schedule,
          onReservationRequest = _this$props.onReservationRequest;
      var credits = schedule.availability.credits;
      var scheduleId = schedule.id;
      var venueId = schedule.venue.id;
      onReservationRequest(scheduleId, venueId, {
        credits: credits,
        schedule: scheduleId
      });
    });

    return _this;
  }

  _createClass(Inquiry, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var lateCancellation = this.props.schedule.venue.late_cancellation;
      this.setState({
        isDisabled: lateCancellation === CANCELLATION_LATE
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          endOfCycleDate = _this$props2.endOfCycleDate,
          msaTimeZone = _this$props2.msaTimeZone,
          schedule = _this$props2.schedule;

      var _mapSchedulePropertie = mapScheduleProperties(schedule),
          credits = _mapSchedulePropertie.credits,
          klassName = _mapSchedulePropertie.klassName,
          cancellationPolicy = _mapSchedulePropertie.cancellationPolicy,
          endTime = _mapSchedulePropertie.endTime,
          source = _mapSchedulePropertie.source,
          startTime = _mapSchedulePropertie.startTime,
          venueName = _mapSchedulePropertie.venueName,
          locationName = _mapSchedulePropertie.locationName,
          imageUrl = _mapSchedulePropertie.imageUrl,
          lateCancellation = _mapSchedulePropertie.lateCancellation,
          timeZone = _mapSchedulePropertie.timeZone;

      var isDisabled = this.state.isDisabled;
      return React.createElement("div", {
        className: "reservation reservation--inquiry"
      }, imageUrl && React.createElement("div", {
        className: "modal__header__img",
        style: {
          backgroundImage: "url(\"".concat(imageUrl, "\")")
        }
      }), React.createElement("div", {
        className: "reservation--inquiry__body"
      }, React.createElement("div", {
        className: "reservation__class-name mb"
      }, klassName), React.createElement("div", {
        className: "reservation__venue"
      }, "".concat(venueName, " - ").concat(locationName)), React.createElement("div", {
        className: "reservation__date mt+ text--xl"
      }, React.createElement(FormattedDate, {
        value: shiftTimezone(startTime, timeZone) * 1000,
        weekday: "long",
        month: "long",
        day: "numeric"
      })), React.createElement("div", {
        className: "reservation__time mb text--xl"
      }, React.createElement(TimeRange, {
        startTimestamp: shiftTimezone(startTime, timeZone),
        endTimestamp: shiftTimezone(endTime, timeZone)
      })), React.createElement("div", {
        className: "reservation--inquiry__body__credits"
      }, React.createElement(FormattedHTMLMessage, _extends({}, messages.inquiryCredits, {
        values: {
          credits: credits
        }
      }))), React.createElement(CancellationPolicy, {
        onLateCancellationConfirmation: this.handleLateCancellationConfirmation,
        lateCancellation: lateCancellation,
        cancellationPolicy: cancellationPolicy,
        endOfCycleDate: endOfCycleDate,
        msaTimeZone: msaTimeZone
      }, React.createElement("button", {
        className: classNames('bt bt--primary bt--lg bt--width-lg', {
          'bt--disabled': isDisabled
        }),
        disabled: isDisabled,
        onClick: this.handleReservationRequest
      }, React.createElement(FormattedMessage, messages.inquiryReserve)))), source === SCHEDULE_SOURCE_MINDBODY && React.createElement(MindBodyLink, null));
    }
  }]);

  return Inquiry;
}(PureComponent);
Inquiry.propTypes = {
  endOfCycleDate: PropTypes.number.isRequired,
  msaTimeZone: PropTypes.string.isRequired,
  onReservationRequest: PropTypes.func.isRequired,
  schedule: schedulesShape
};